<template>
  <div class="userBody">
    <!-- 拖拽上传覆盖层 -->
    <div v-if="isDragOver" class="drag-overlay">
      <div class="drag-overlay-content">
        <i class="el-icon-upload2"></i>
        <span>释放图片以上传</span>
      </div>
    </div>
    <div id="userWindow" class="userWindow">
      <div ref="userLeftRef" class="userLeft">
        <div ref="openCloseRef" class="open-close" @click="handleClose()">
          <i class="el-icon-arrow-left close"></i>
          <i class="el-icon-arrow-right open"></i>
        </div>
        <div class="userLeft-left">
          <div>
            <div class="item">
              <img style="width: 40px; height: 40px" src="@/assets/images/login/u69.png" />
            </div>
            <div
              :class="chatActive ? 'active' : ''"
              class="item logo"
              @click="handleCreateNewChat()"
            >
              <img src="@/assets/images/left/1-1.png" />
              <div style="margin-top: 7px; font-size: 12px">
                <span>{{ $t("common.conversation") }}</span>
              </div>
            </div>
          </div>
          <div v-if="isLogin">
            <div class="item" @click="handleOpenD123()">
              <img src="@/assets/images/login/d123.png" style="width: 25px; height: 25px" alt="" />
              <div style="margin-top: 7px; font-size: 10px">
                <span>{{ $t("home.dtx") }}</span>
              </div>
            </div>
            <div class="item" @click="handleOpenVip()">
              <img src="@/assets/images/login/vip.png" style="width: 25px; height: 25px" alt="" />
              <div style="margin-top: 7px; font-size: 10px">
                <span>{{ $t("home.subscribe") }}</span>
              </div>
            </div>
            <div>
              <el-dropdown placement="left-end" @command="handleCommand">
                <div style="position: relative; cursor: pointer">
                  <img
                    v-if="vipType"
                    class="vip-head-ranking"
                    src="@/assets/images/login/vip-head.png"
                  />
                  <el-avatar v-if="headImagePath" :size="40" :src="headImagePath" @error="true">
                    <img
                      style="width: 100%; height: 100%"
                      :src="require('@/assets/images/head_img.png')"
                    />
                  </el-avatar>
                  <el-avatar v-else :size="40" :src="require('@/assets/images/head_img.png')" />
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="loginOut">{{ $t("common.logout") }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <div class="userLeft-line"></div>
        <div ref="userLeftRightRef" class="userLeft-right">
          <div style="width: 100%; display: flex; align-items: center; justify-content: center">
            <el-button
              style="width: 80%; border-width: 3px; height: 38px; text-align: center"
              round
              size="mini"
              @click="handleCreateNewChat()"
            >
              {{ $t("common.newChat") }}
            </el-button>
          </div>
          <history-session
            :session-history-list="sessionHistoryList"
            @getHistory="handleGetHistory"
          />
        </div>
      </div>
      <div class="userRight">
        <!--信息窗口-->
        <home-ai-chat
          v-if="showChat"
          id="userMessage"
          :key="childKey"
          ref="homeAiChatRef"
          :message-list="messageList"
          class="userMessage"
          :session-id="sessionId"
          :channel-id="channelId"
          :init-loading="initLoading"
          :send-loading="sendMessageLoading"
          @rollbackLoading="handleLoading"
          @sendChannelId="handleChannelId"
        >
        </home-ai-chat>

        <!--底部发送 ;-->
        <div v-if="channelId !== 3" class="customerChatFootDiv">
          <div class="customerChatTool">
            <!--发送内容-->
            <div style="height: calc(100% - 50px)">
              <input
                ref="imageInputRef"
                type="file"
                accept="image/*"
                multiple
                style="display: none"
                @change="handleImagePick"
              />
              <div v-if="imageAttachments.length > 0" class="image-attachments">
                <div
                  v-for="item in imageAttachments"
                  :key="item.id"
                  class="image-attachment"
                  :class="{ loading: item.loading }"
                >
                  <img
                    :src="item.localUrl || item.url"
                    referrerpolicy="no-referrer"
                    @click="previewInputImage(item.localUrl || item.url)"
                  />
                  <span v-if="item.loading" class="uploading-text">{{ $t("home.uploading") }}</span>
                  <button type="button" @click.stop="removeImageAttachment(item.id)">
                    &times;
                  </button>
                </div>
              </div>
              <textarea
                v-model.trim="sendData"
                class="customerChatText"
                maxlength="100"
                :placeholder="
                  isRecording ? liveTranscript || $t('home.listening') : $t('home.inputPlaceholder')
                "
                :disabled="sendMessageLoading"
                :style="sendMessageLoading ? 'cursor: not-allowed;' : ''"
                @keyup.enter.prevent="enterSendMessage"
              ></textarea>
              <button
                type="button"
                class="image-upload-btn"
                :disabled="sendMessageLoading"
                :title="$t('home.uploadImage')"
                @click="triggerImagePick"
              >
                <i class="el-icon-picture-outline"></i>
              </button>
              <!-- 停止按钮 -->
              <button v-if="sendMessageLoading" class="stop-btn" @click="handleAbort()">
                <svg viewBox="0 0 24 24">
                  <rect x="6" y="6" width="12" height="12" />
                </svg>
              </button>
              <button
                v-if="!sendMessageLoading"
                type="button"
                class="voice-btn"
                :class="{ recording: isRecording }"
                :disabled="sendMessageLoading"
                :title="$t('home.holdToSpeak')"
                @mousedown="startVoiceInput"
                @mouseup="finishVoiceInput"
                @mouseleave="cancelVoiceInput"
                @touchstart.prevent="startVoiceInput"
                @touchend.prevent="finishVoiceInput"
                @touchcancel.prevent="cancelVoiceInput"
              >
                <i class="el-icon-microphone"></i>
                <div v-if="isRecording" class="recording-pop">
                  <div class="wave-bars"><span></span><span></span><span></span><span></span></div>
                  <div>{{ liveTranscript || $t("home.listeningShort") }}</div>
                  <small>{{ recordSeconds }}s / {{ $t("home.releaseToSend") }}</small>
                </div>
              </button>
              <el-button
                v-if="!sendMessageLoading"
                type="text"
                size="mini"
                :loading="sendMessageLoading"
                :disabled="sendMessageLoading"
                icon="el-icon-s-promotion"
                class="customerChatButton"
                @click="sendMessage(sendData)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--     登录-->
    <Login
      :active-name="activeName"
      :show-modal="showModal"
      @closeLogin="closeLogin"
      @changeActiveName="changeActiveNameEnterprise"
    ></Login>
  </div>
</template>

<script>
import ChatApi from "@/api/chat";
import { getChannelById } from "@/constants/channel";
import SessionApi from "@/api/session";
import UserLogin from "./login/userLogin";
import ChannelDialog from "./ChannelDialog";
import HomeAiChat from "./HomeAiChat";
import HistorySession from "./HistorySession/index";
import { listToTree } from "@/utils/util";
import Login from "./login/Login";
import { ASRSession, uploadLeadsqaImage, validateImageFile } from "@/utils/multimodal";

export default {
  name: "PcHome",
  components: {
    Login,
    HistorySession,
    HomeAiChat,
    ChannelDialog,
    UserLogin,
  },
  data() {
    return {
      childKey: 0,
      showChat: true,
      chatActive: true,
      showInit: true,
      uploadImg: {},
      isFirst: true,
      showHistoryDialog: false,
      sendMessageLoading: false,
      sessionHistoryList: [],
      query: {
        page: 0,
        size: 1000,
        total: 0,
      },
      showChannelDialog: false,
      sessionId: null,
      channelId: null,
      messageList: [],
      sendData: "",
      maxImageCount: 3,
      imageAttachments: [],
      asrSession: null,
      isRecording: false,
      liveTranscript: "",
      recordSeconds: 0,
      recordTimer: null,
      initLoading: true,
      activeName: "", // 登录tabs栏的切换状态
      showModal: false,
      isDragOver: false,
      dragCounter: 0,
    };
  },
  computed: {
    userId() {
      return this.$store.state.user.userId;
    },
    isLogin() {
      return this.$store.state.user.userId != null;
    },
    headImagePath() {
      return this.$store.state.user.headImagePath;
    },
    vipType() {
      return this.$store.state.user.vipType;
    },
  },
  mounted() {
    this.initialization();
    this.bindPasteEvent();
    this.bindDragEvents();
  },
  beforeDestroy() {
    this.clearVoiceInput();
    this.imageAttachments.forEach((item) => {
      if (item.localUrl) {
        URL.revokeObjectURL(item.localUrl);
      }
    });
    this.unbindPasteEvent();
    this.unbindDragEvents();
  },
  methods: {
    bindPasteEvent() {
      this._handlePaste = this.handlePaste.bind(this);
      document.addEventListener("paste", this._handlePaste);
    },
    unbindPasteEvent() {
      document.removeEventListener("paste", this._handlePaste);
    },
    bindDragEvents() {
      this._handleDragEnter = this.onDragEnter.bind(this);
      this._handleDragOver = this.onDragOver.bind(this);
      this._handleDragLeave = this.onDragLeave.bind(this);
      this._handleDrop = this.onDrop.bind(this);
      this._handleWindowBlur = this.onWindowBlur.bind(this);

      const el = this.$el;
      el.addEventListener("dragenter", this._handleDragEnter);
      el.addEventListener("dragover", this._handleDragOver);
      el.addEventListener("dragleave", this._handleDragLeave);
      el.addEventListener("drop", this._handleDrop);
      window.addEventListener("blur", this._handleWindowBlur);
    },
    unbindDragEvents() {
      const el = this.$el;
      el.removeEventListener("dragenter", this._handleDragEnter);
      el.removeEventListener("dragover", this._handleDragOver);
      el.removeEventListener("dragleave", this._handleDragLeave);
      el.removeEventListener("drop", this._handleDrop);
      window.removeEventListener("blur", this._handleWindowBlur);
    },
    handlePaste(event) {
      const items = (event.clipboardData || event.originalEvent.clipboardData).items;
      if (!items) return;

      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          event.preventDefault();
          const file = items[i].getAsFile();
          if (file) {
            this.addImageAttachment(file);
          }
          return;
        }
      }
      // 文本粘贴不做处理，正常粘贴
    },
    onDragEnter(event) {
      event.preventDefault();
      // 只处理文件拖拽
      if (event.dataTransfer.types && event.dataTransfer.types.includes('Files')) {
        this.dragCounter++;
        this.isDragOver = true;
      }
    },
    onDragOver(event) {
      event.preventDefault();
    },
    onDragLeave(event) {
      event.preventDefault();
      this.dragCounter--;
      if (this.dragCounter <= 0) {
        this.dragCounter = 0;
        this.isDragOver = false;
      }
    },
    onDrop(event) {
      event.preventDefault();
      this.isDragOver = false;
      this.dragCounter = 0;
      const files = Array.from(event.dataTransfer.files);

      if (files.length > 0) {
        files.forEach((file) => {
          this.addImageAttachment(file);
        });
      }
    },
    onWindowBlur() {
      // 窗口失去焦点时隐藏覆盖层
      this.isDragOver = false;
      this.dragCounter = 0;
    },
    async addImageAttachment(file) {
      if (!this.ensureLogin()) {
        return;
      }

      // 验证图片
      const validation = validateImageFile(file);
      if (!validation.valid) {
        this.$message.error(validation.message);
        return;
      }

      // 检查数量限制
      if (this.imageAttachments.length >= this.maxImageCount) {
        this.$message.warning("已超过上传图片数量限制");
        return;
      }

      const item = {
        id: `${Date.now()}-${Math.random()}`,
        name: file.name || `paste-${Date.now()}.png`,
        localUrl: URL.createObjectURL(file),
        url: "",
        fileInfo: null,
        loading: true,
      };

      this.imageAttachments.push(item);

      try {
        const fileInfo = await uploadLeadsqaImage(file, {
          sendId: this.userId,
          source: 1,
        });
        item.fileInfo = fileInfo;
        item.url = fileInfo.url;
        item.loading = false;
      } catch (error) {
        this.removeImageAttachment(item.id);
        this.$message.error(error.message || "图片上传失败");
      }
    },
    handleAbort() {
      this.$refs.homeAiChatRef.handleAbort();
    },
    handleOpenD123() {
      window.open(process.env.VUE_APP_D123_URL, "_blank");
    },
    handleOpenVip() {
      window.open(process.env.VUE_APP_D123_URL + "/memberCenter/?op=dxxOpenVip", "_blank");
    },
    ensureLogin() {
      if (this.isLogin) {
        return true;
      }
      window.location.href = process.env.VUE_APP_D123_URL + "/?op=dxxLogin";
      return false;
    },
    handleCommand(command) {
      if (command === "loginOut") {
        this.handleLoginOut();
      }
    },
    handleClose() {
      const openCloseDiv = this.$refs.openCloseRef;
      const openDiv = openCloseDiv.querySelector(".open");
      const closeDiv = openCloseDiv.querySelector(".close");
      const userLeftRightDiv = this.$refs.userLeftRightRef;
      const userLeftDiv = this.$refs.userLeftRef;
      if (getComputedStyle(openDiv).display !== "none") {
        // 点击展开操作
        openDiv.style.display = "none";
        closeDiv.style.display = "block";
        openCloseDiv.style.left = "330px";
        userLeftRightDiv.style.transform = "translateX(0px)";
        userLeftDiv.style.width = "330px";
      } else {
        // 点击收起操作
        openDiv.style.display = "block";
        closeDiv.style.display = "none";
        openCloseDiv.style.left = "60px";
        userLeftRightDiv.style.transform = "translateX(-270px)";
        userLeftDiv.style.width = "60px";
      }
    },
    async checkImages(images) {
      const rightImages = [];
      if (images && images.length > 0) {
        for (let i = 0; i < images.length; i++) {
          try {
            const res = await fetch(images[i]);
            if (res.status === 200) {
              const imageBlob = await res.blob();
              if (imageBlob.size > 100) {
                rightImages.push(images[i]);
              }
            }
          } catch (e) {}
        }
      }
      return rightImages;
    },
    async reStarChat() {
      this.sendMessageLoading = true;
      this.showChat = false;
      setTimeout(() => {
        this.showChat = true;
        this.childKey += 1;
      });
    },
    handleChannelId(channelId) {
      this.channelId = channelId;
      this.getSessionHistory();
    },
    handleOpenElement() {
      window.location.href = "/element";
    },
    async handleCreateNewChat() {
      if (!this.ensureLogin()) {
        return;
      }
      await this.reStarChat();
      this.isFirst = true;
      await this.createSession();
      this.sendMessageLoading = false;
    },
    handleLoading(val) {
      this.sendMessageLoading = val;
    },
    async initialization() {
      if (!this.isLogin) {
        // 未登录
        await this.createSession();
      } else {
        const params = this.$route.params;
        const sessionId = params.sessionId;
        // 同步执行，查询最新
        await this.getSessionHistory();
        if (!sessionId) {
          // 新会话
          await this.createSession();
          return;
        }
        await this.handleGetHistory(sessionId);
      }
    },
    async handleGetHistory(sessionId) {
      await this.reStarChat();
      this.isFirst = true;
      this.sessionId = sessionId;
      this.sessionHistoryList.forEach((item) => {
        if (sessionId === item.id) {
          item.active = true;
        } else {
          item.active = false;
        }
      });
      // 获取用户最新的一个会话，获取信息并展示
      const res = await this.axios.get(ChatApi.getChatHistory, { params: { sessionId } });
      if (res && res.length > 0) {
        this.channelId = res[res.length - 1].channelId;
        await this.$refs.homeAiChatRef.handleEditInitShow(false);
        for (const item of res) {
          item.isCopy = false;
          // messageStatus: 0=未评价, 1=不喜欢, 2=喜欢 → like: null=未评价
          if (item.messageStatus === 2) {
            item.like = 0;
          } else if (item.messageStatus === 1) {
            item.like = 1;
          } else {
            item.like = null;
          }
          if (item.isPdf && item.pdfPath) {
            const pdfImages = item.pdfPath.split(",");
            const rightImages = await this.checkImages(pdfImages);
            if (rightImages.length > 0) {
              item.pdfPath = rightImages;
            } else {
              item.pdfPath = "";
            }
          } else {
            item.pdfPath = "";
          }
          try {
            item.citePath = item.citePath ? JSON.parse(item.citePath) : [];
          } catch (e) {
            item.citePath = [];
          }
          // 解析 file_list JSON 字符串
          if (item.file_list && typeof item.file_list === 'string') {
            try {
              item.file_list = JSON.parse(item.file_list);
            } catch (e) {
              item.file_list = [];
            }
          }
          // 拼接 OSS URL
          let ossBaseUrl = (process.env.VUE_APP_OSS_URL || 'https://dq123oss.dq123.com').replace(/\/+$/, '');
          if (ossBaseUrl) {
            ossBaseUrl = ossBaseUrl + '/';
          }
          // 处理 file_list 字段，拼接 OSS URL，并将图片提取到 imageUrls
          if (item.file_list && Array.isArray(item.file_list)) {
            item.file_list = item.file_list.map(file => ({
              ...file,
              url: ossBaseUrl + (file.oss_path || '').replace(/^\/+/, ''),
            }));
            // 将 file_list 中 kind=image 的项提取到 imageUrls，确保历史图片能正常显示
            item.imageUrls = item.file_list
              .filter(file => file.kind === 'image' && file.url)
              .map(file => file.url);
          }
        }
        // 获取对应渠道的配置问题
        const homeAiChatDiv = document.getElementById("userMessage");
        if (this.channelId === 3) {
          homeAiChatDiv.style.height = "100%";
          const obj = Object.assign({
            channelId: this.channelId,
            sessionId: sessionId,
            title: this.$t("chat.title.canGenerateForm"),
            sendTime: this.$options.filters.formatDate(new Date()),
            roleType: "bomForm",
          });
          res.push(obj);
        } else {
          homeAiChatDiv.height = "calc(100% - 160px)";
          if (this.channelId) {
            // 获取对应渠道的配置问题
            const channelRes = getChannelById(this.channelId);
            if (channelRes.message) {
              const message = JSON.parse(channelRes.message);
              const obj = Object.assign({
                channelId: this.channelId,
                sessionId: sessionId,
                title: this.$t("chat.title.tryAsk"),
                questions: message,
                sendTime: this.$options.filters.formatDate(new Date()),
                roleType: "more",
              });
              res.push(obj);
            }
          }
        }
        this.messageList = listToTree(res, { idKey: "id", parentKey: "parentId" });
        this.toBottom(200);
      } else {
        this.messageList = [];
        // 获取该渠道下的热门问题
        await this.$refs.homeAiChatRef.handleEditInitShow(true);
      }
      this.initLoading = false;
      this.sendMessageLoading = false;
    },
    // 生成会话id
    async createSession() {
      const res = await this.axios.get(SessionApi.createSession);
      if (res) {
        this.$router.push({ name: "home" }).catch(() => {});
        this.sessionId = res;
        this.channelId = null;
        this.messageList = [];
        // 获取该渠道下的热门问题
        await this.$refs.homeAiChatRef.handleEditInitShow(true);
        this.initLoading = false;
      }
    },
    // 获取历史会话
    async getSessionHistory() {
      const that = this;
      const res = await that.axios.get(SessionApi.getSessionHistory, { params: this.query });
      res.content.forEach((item, index) => {
        item.active = false;
        item.showEdit = false;
      });
      that.sessionHistoryList = res.content;
      that.query.total = res.totalElements;
      if (that.query.total) {
        this.showHistoryDialog = true;
      }
    },
    enterSendMessage(event) {
      event.preventDefault();
      // if (event.ctrlKey) {
      //   this.sendData += '\n';
      //   return;
      // }
      if (this.sendMessageLoading) {
        return;
      }
      this.sendMessage(this.sendData);
    },
    triggerImagePick() {
      if (!this.ensureLogin()) {
        return;
      }
      if (!this.sendMessageLoading && this.$refs.imageInputRef) {
        this.$refs.imageInputRef.click();
      }
    },
    async handleImagePick(event) {
      if (!this.ensureLogin()) {
        event.target.value = "";
        return;
      }
      const files = Array.from(event.target.files || []);
      event.target.value = "";
      let hasExceededLimit = false;
      for (const file of files) {
        if (this.imageAttachments.length >= this.maxImageCount) {
          hasExceededLimit = true;
          break;
        }
        const validation = validateImageFile(file);
        if (!validation.valid) {
          this.$message.error(validation.message);
          continue;
        }
        const item = {
          id: `${Date.now()}-${Math.random()}`,
          name: file.name,
          localUrl: URL.createObjectURL(file),
          url: "",
          fileInfo: null,
          loading: true,
        };
        this.imageAttachments.push(item);
        try {
          const fileInfo = await uploadLeadsqaImage(file, {
            sendId: this.userId,
            source: 1,
          });
          item.fileInfo = fileInfo;
          item.url = fileInfo.url;
          item.loading = false;
        } catch (error) {
          this.removeImageAttachment(item.id);
          this.$message.error(error.message || "图片上传失败");
        }
      }
      if (hasExceededLimit) {
        this.$message.warning("已超过上传图片数量 请删减！");
      }
    },
    removeImageAttachment(id) {
      const index = this.imageAttachments.findIndex((item) => item.id === id);
      if (index === -1) {
        return;
      }
      const [item] = this.imageAttachments.splice(index, 1);
      if (item.localUrl) {
        URL.revokeObjectURL(item.localUrl);
      }
    },
    previewInputImage(url) {
      this.$refs.homeAiChatRef.$refs.viewPicture.openView(1, url, false);
    },
    async startVoiceInput() {
      if (!this.ensureLogin()) {
        return;
      }
      if (this.isRecording || this.sendMessageLoading) {
        return;
      }
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.$message.warning("当前浏览器不支持录音");
        return;
      }
      this.isRecording = true;
      this.liveTranscript = "";
      this.recordSeconds = 0;
      this.asrSession = new ASRSession({
        sendId: this.userId,
        source: 1,
        onPartial: (text) => {
          this.liveTranscript = text;
        },
        onFinal: (text) => {
          this.liveTranscript = text;
        },
        onError: (message) => {
          this.$message.warning(message || "语音识别异常");
        },
      });
      try {
        await this.asrSession.start();
      } catch (error) {
        this.$message.warning(
          error.message === "ws error" ? "无法建立语音识别连接" : "麦克风访问失败"
        );
        this.clearVoiceInput();
        return;
      }
      this.recordTimer = setInterval(() => {
        this.recordSeconds += 1;
        if (this.recordSeconds >= 60) {
          this.finishVoiceInput();
        }
      }, 1000);
    },
    async finishVoiceInput() {
      if (!this.isRecording) {
        return;
      }
      const asrSession = this.asrSession;
      this.isRecording = false;
      if (this.recordTimer) {
        clearInterval(this.recordTimer);
        this.recordTimer = null;
      }
      let result = { text: this.liveTranscript, hasAudio: true };
      try {
        result = await asrSession.stop();
      } catch (error) {
        // keep the best-effort transcript already displayed
      }
      this.asrSession = null;
      const text = (result.text || "").trim();
      if (!result.hasAudio || !text) {
        this.$message.warning("未识别到语音，请重新长按说话");
        this.liveTranscript = "";
        this.recordSeconds = 0;
        return;
      }
      this.sendData = this.sendData ? `${this.sendData} ${text}` : text;
      this.liveTranscript = "";
      this.recordSeconds = 0;
    },
    cancelVoiceInput() {
      if (!this.isRecording) {
        return;
      }
      this.clearVoiceInput();
    },
    clearVoiceInput() {
      if (this.recordTimer) {
        clearInterval(this.recordTimer);
        this.recordTimer = null;
      }
      if (this.asrSession) {
        this.asrSession.close();
        this.asrSession = null;
      }
      this.isRecording = false;
      this.liveTranscript = "";
      this.recordSeconds = 0;
    },
    // 消息发送
    async sendMessage(data) {
      if (!this.ensureLogin()) {
        return;
      }

      // 判断空
      const readyImages = this.imageAttachments.filter((item) => item.url).map((item) => item.url);
      const readyFileList = this.imageAttachments
        .filter((item) => item.fileInfo)
        .map((item) => item.fileInfo);
      if (this.imageAttachments.some((item) => item.loading)) {
        this.$message.warning("图片仍在上传，请稍后发送");
        return;
      }
      if (!data && readyImages.length < 1) {
        this.$message.warning("发送内容不能为空");
        this.sendData = "";
        return;
      }
      this.sendMessageLoading = true;
      // 存入自己的消息列表
      const obj = Object.assign({
        channelId: this.channelId,
        sessionId: this.sessionId,
        sendMessage: data || "请识别图片内容",
        imageUrls: readyImages,
        file_list: readyFileList,
        sendTime: this.$options.filters.formatDate(new Date()),
        roleType: 2,
      });
      this.messageList.push(obj);
      this.sendData = "";
      this.imageAttachments.forEach((item) => {
        if (item.localUrl) {
          URL.revokeObjectURL(item.localUrl);
        }
      });
      this.imageAttachments = [];
      this.toBottom(200);
      // 子组件发送ai请求
      if (this.isFirst) {
        this.$refs.homeAiChatRef.handleEditInitShow(false);
      }
      // if ((data.indexOf('上传') > -1 || data.indexOf('识别') > -1) && data.indexOf('表格') > -1) {
      //   let obj = Object.assign({
      //     channelId: 3,
      //     sessionId: this.sessionId,
      //     sendTime: this.$options.filters['formatDate'](new Date),
      //     roleType: 'upload',
      //   });
      //   this.messageList.push(obj);
      // } else {
      //   await this.$refs.homeAiChatRef.aiReply(obj);
      // }
      await this.$refs.homeAiChatRef.aiReply(obj);
      if (this.isFirst) {
        this.isFirst = false;
        this.getSessionHistory();
      }
      this.sendMessageLoading = false;
    },

    // 回到底部
    toBottom(time) {
      setTimeout(() => {
        const RightCont = document.getElementById("userMessage");
        if (RightCont != null) {
          const scrollHeight2 = RightCont.scrollHeight;
          RightCont.scrollTop = scrollHeight2;
        }
      }, time);
      clearTimeout();
    },

    // 退出登录
    async handleLoginOut() {
      await this.$store.dispatch("user/logout");
      this.$router.go(0);
    },
    // 改变登录tab栏的状态 -- 企业
    changeActiveNameEnterprise() {
      this.activeName = "second";
    },
    // 登录弹出框的x符号
    closeLogin() {
      this.showModal = false;
      this.$store.dispatch("login/closeLoginDialog");
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/mixin.scss";

.userBody {
  background: linear-gradient(180deg, rgba(230, 238, 254, 1) 0%, rgba(240, 241, 254, 1) 100%);
  font-size: 14px;
  color: #000000;
  width: 100%;
  height: 100%;
  position: relative;

  /* 拖拽上传覆盖层 */
  .drag-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;

    .drag-overlay-content {
      background: white;
      padding: 40px 60px;
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);

      i {
        font-size: 48px;
        color: #ff6a00;
      }

      span {
        font-size: 18px;
        color: #333;
        font-weight: 500;
      }
    }
  }

  /* 停止按钮样式 */
  .stop-btn {
    position: absolute;
    bottom: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: none;
    background-color: #e74c3c; /* 红色背景 */
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  /* 按钮悬停效果 */
  .stop-btn:hover {
    background-color: #c0392b; /* 深色变体 */
  }

  /* 停止按钮的 SVG 图标 */
  .stop-btn svg {
    width: 20px;
    height: 20px;
    fill: white;
  }

  .user-history-info {
    margin-top: 30px;
    cursor: pointer;
    padding: 0 10px;
    background-color: #f7f7f7;
    border-radius: 8px;
    color: #333333;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:active {
      background-color: #e0e0e0;
    }
  }

  .userWindowHeader {
    height: 60px;
    border: 1px solid #dddddd;
  }

  .userWindow {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    display: flex;

    .userLeft {
      width: 330px;
      @include respond-to("other") {
        width: 60px;
      }
      overflow: hidden;
      display: flex;
      transition: width 0.167s cubic-bezier(0.4, 0.8, 0.74, 1);
      .open-close {
        left: 330px;
        @include respond-to("other") {
          left: 60px;
        }
        align-items: center;
        background-color: #eff4ff;
        border-radius: 49px;
        cursor: pointer;
        display: inline-flex;
        height: 41px;
        justify-content: center;
        margin-left: 20px;
        position: absolute;
        top: calc(50% - 20px);
        transition: left 0.167s cubic-bezier(0.4, 0.8, 0.74, 1);
        width: 14px;
        z-index: 11;
        &:hover {
          background-color: #dae1f1;
        }
        .close {
          display: block;
          @include respond-to("other") {
            display: none;
          }
        }
        .open {
          display: none;
          @include respond-to("other") {
            display: block;
          }
        }
      }
      .userLeft-left {
        padding: 20px 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .item {
          width: 45px;
          height: 45px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          cursor: pointer;
        }
        .logo {
          border-radius: 10px;
          &:hover {
            background-color: #ffffff;
          }
        }
      }
      .userLeft-line {
        border-right: 2px solid #e1dfef;
        margin: 20px 0px;
      }
      .userLeft-right {
        transition: transform 0.167s cubic-bezier(0.4, 0.8, 0.74, 1);
        transform: translateX(0px);
        padding: 20px 0 20px 10px;
        flex: 1;
      }
      @include respond-to("other") {
        .userLeft-right {
          transform: translateX(-270px);
        }
      }
    }

    .userRight {
      flex: 1;
      background-color: #ffffff;
      margin: 20px 20px 20px 10px;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .userMessage {
        overflow-y: auto;
        padding: 10px;
        width: 80%;
        margin-bottom: 10px;
        height: calc(100% - 160px);
        word-wrap: break-word;
        border-radius: 10px;
      }

      .customerChatFootDiv {
        width: 50%;
        position: fixed;
        bottom: 30px;
        z-index: 1111;
        background: #fff;
        border: 1px solid #ff6a00;
        box-sizing: border-box;
        padding: 5px;
        height: 140px;
        border: 1px solid #ff6a00;
        box-shadow: 0 3px 5px rgb(199 199 199 / 40%);
        border-radius: 10px;

        .customerChatTool {
          position: relative;
          height: 100%;

          .customerChatToolList {
            width: 100%;
            height: 45px;
            padding: 0 10px;
            border: 1px solid #dddddd;
            color: gray;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          .customerChatText {
            width: 99%;
            height: 100%;
            border: none;
            outline: none;
            padding: 10px 92px 32px 42px;
            box-sizing: border-box;
            resize: none;
          }

          .image-attachments {
            position: absolute;
            left: 8px;
            right: 8px;
            top: -58px;
            display: flex;
            gap: 8px;
            padding: 6px;
            overflow-x: auto;
            background: rgba(255, 255, 255, 0.92);
            border: 1px solid #f1d2bd;
            border-radius: 10px;
            box-shadow: 0 4px 12px rgb(199 199 199 / 28%);
          }

          .image-attachment {
            position: relative;
            width: 44px;
            height: 44px;
            flex: 0 0 auto;
            border-radius: 8px;
            overflow: hidden;
            background: #fff4ec;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              cursor: zoom-in;
            }

            .uploading-text {
              position: absolute;
              inset: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 12px;
              color: #ffffff;
              background: rgba(0, 0, 0, 0.45);
            }

            button {
              position: absolute;
              top: -2px;
              right: -2px;
              width: 18px;
              height: 18px;
              border: none;
              border-radius: 50%;
              color: #ffffff;
              background: rgba(0, 0, 0, 0.58);
              cursor: pointer;
            }
          }

          .image-upload-btn,
          .voice-btn,
          .customerChatButton {
            position: absolute;
            width: 34px;
            height: 34px;
            min-width: 34px;
            padding: 0;
            border: none;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ff6a00;
            background: linear-gradient(180deg, #fff8f3 0%, #fff0e6 100%);
            box-shadow: 0 2px 8px rgba(255, 106, 0, 0.12);
            cursor: pointer;
            font-size: 18px;
            line-height: 34px;
            transition: all 0.18s ease;
          }

          .image-upload-btn:hover,
          .voice-btn:hover,
          .customerChatButton:hover {
            color: #ffffff;
            background: #ff6a00;
            box-shadow: 0 4px 12px rgba(255, 106, 0, 0.26);
            transform: translateY(-1px);
          }

          .image-upload-btn:disabled,
          .voice-btn:disabled,
          .customerChatButton.is-disabled {
            color: #c0c4cc;
            background: #f4f4f5;
            box-shadow: none;
            cursor: not-allowed;
            transform: none;
          }

          .image-upload-btn {
            left: 12px;
            bottom: 12px;
          }

          .voice-btn {
            right: 56px;
            bottom: 12px;
          }

          .voice-btn.recording {
            color: #ffffff;
            background: #ff6a00;
            box-shadow: 0 0 0 8px rgba(255, 106, 0, 0.14);
          }

          .recording-pop {
            position: absolute;
            right: 0;
            bottom: 42px;
            width: 220px;
            padding: 12px;
            line-height: 20px;
            border-radius: 12px;
            color: #333333;
            background: #ffffff;
            border: 1px solid #f1d2bd;
            box-shadow: 0 8px 22px rgb(199 199 199 / 35%);
            text-align: center;
            pointer-events: none;
          }

          .wave-bars {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 4px;
            margin-bottom: 8px;

            span {
              width: 4px;
              height: 12px;
              border-radius: 10px;
              background: #ff6a00;
              animation: voice-wave 0.8s ease-in-out infinite;
            }

            span:nth-child(2) {
              animation-delay: 0.1s;
            }

            span:nth-child(3) {
              animation-delay: 0.2s;
            }

            span:nth-child(4) {
              animation-delay: 0.3s;
            }
          }

          @keyframes voice-wave {
            0%,
            100% {
              transform: scaleY(0.65);
            }
            50% {
              transform: scaleY(1.45);
            }
          }

          .customerChatButton {
            bottom: 12px;
            right: 12px;
          }
        }
      }
    }
  }
}
</style>
